import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLifenIntegrationForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 1.5,
		fill: "currentColor",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.16797 8.00033L5.10214 9.30699L13.8346 2.16699L2.16797 8.00033ZM7.41814 10.3337L12.6681 12.667L13.8348 2.16699L7.41814 10.3337ZM5.66814 13.8331L7.20496 10.7594C7.21116 10.7625 7.21745 10.7655 7.22383 10.7683L9.64286 11.8457L5.66814 13.8331Z",
		fill: "white"
	})]
});
export default SvgLifenIntegrationForward;
